export const wsFeedUrl = 'wss://norma.nomoreparties.space/orders/all';
export const wsProfileOrdersUrl = 'wss://norma.nomoreparties.space/orders';
